import React from 'react'
import InputRange from 'react-input-range';

export default function ListingPriceFilter({ rangeValue, setRangeValue }) {
  const rangeValueFloored = {
    min: rangeValue.min < 0 ? 0 : rangeValue.min,
    max: rangeValue.max > 100 ? 100 : rangeValue.max
  }
  return (
    <div className="mt-6 mb-12 md:my-0">
      <h3 className="text-md text-black font-bold mb-4">Price Range</h3>
      <div className="w-full flex justify-between">
        <p className='leading-loose text-gray-800 text-md'>
          {!rangeValue.min || rangeValue.min === '0' ? '$0' : `$${rangeValue.min}k`}
        </p>
        <p className='leading-loose text-gray-800 text-md'>
          {!rangeValue.max || rangeValue.max >= 100 ? "$100k+" : `$${rangeValue.max}k`}
        </p>
      </div>
      <div className="mb-5 mt-2 px-2">
        <InputRange
          maxValue={100}
          minValue={0}
          step={5}
          formatLabel={value => `$${value}${value === 100000 ? 'k+' : ''}`}
          value={rangeValueFloored}
          onChange={value => {
            setRangeValue({
              min: value.min,
              max: value.max
            })
          }}
        />
      </div>
    </div>
  )
}
